export default __webpack_public_path__ + "static/icon-tile-anatomy-dark-c818c1bca1414f25dba9bf43d80fc70a7a58805c4f3e854005be43b97d99f274.png";